import React from 'react';
import ChangePasswordForm from '../forms/change-password/ChangePasswordForm';
import UserDetailsForm from '../forms/user-details/UserDetailsForm';
import AccountHomePage from '../forms/account-home-page/AccountHomePage';
import UserAddressesForm from '../forms/user-addresses/UserAddressesForm';
import EmailNotificationSettingsForm from '../forms/email-notification-settings/EmailNotificationSettingsForm';
import PushNotificationsForm from '../forms/push-notifications/PushNotificationsForm';
import ResaleTickets from '../forms/resale-tickets/ResaleTickets';
import UserOrderHistory from '../forms/user-order-history/UserOrderHistory';
import UserDetailsFormData from '../forms/helpers/form-helpers/user-account/user-details-form-data';
import AccountHomePageFormData from '../forms/helpers/form-helpers/user-account/account-home-page-form-data';
import { findOptionInSelectField } from '../forms/helpers/form-helpers/form-field-helpers';
import UserAddressesDisplayFormData from '../forms/helpers/form-helpers/user-account/user-addresses-display-form-data';
import UserTickets from '../forms/user-tickets/UserTickets';
import ChangePasswordFormData from '../forms/helpers/form-helpers/user-account/change-password-form-data';
import { formConstants } from './constants/form-constants';
import { formMessageConstants } from './constants/form-message-constants';
import { isEmpty } from './obj-utils';
import TheOneClub from '../forms/the-one-club/TheOneClub';
import OrderHistoryDisplayFormData from '../forms/helpers/form-helpers/user-account/order-history-display-form-data';
import UserTicketsDisplayFormData from '../forms/helpers/form-helpers/user-account/user-tickets-display-form-data';
import TheOneClubFormData from '../forms/helpers/form-helpers/user-account/the-one-club-form-data';
import TicketsResaleFormData from '../forms/helpers/form-helpers/user-account/tickets-resale-form-data';
import EmailNotificationSettingsFormData from '../forms/helpers/form-helpers/user-account/email-notification-settings-form-data';
import { createDateFromExisting } from './date-utils';
import { formFieldConstants } from './constants/form-field-constants';

export const userAccountConstants = {
    oneClub: 'OneClub',

    address: 'address',
    birthdate: 'birthdate',

    customInterests: 'custom:Interests',
    customMembership: 'custom:Membership',
    membership: 'membership',

    isOneClubMember: 'isOneClubMember',
    customOptIns: 'custom: OptIns',
    customTitle: 'custom: Title',

    email: 'email',
    emailVerified: 'email_verified',
    familyName: 'family_name',
    givenName: 'given_name',
    initials: 'initials',

    name: 'name',
    sub: 'sub',

    somethingWentWrong: 'Something went wrong.'
};

export const userAccountContentConstants = {
    accountHomePage: 'accountHomePage',
    userDetailsForm: 'userDetailsForm',
    changePasswordForm: 'changePasswordForm',
    userAddressesForm: 'userAddressesForm',
    emailNotificationSettings: 'emailNotificationSettings',
    pushNotifications: 'pushNotifications',
    userOrderHistory: 'userOrderHistory',
    userTickets: 'userTickets',
    theOneClub: 'theOneClub',
    resaleTickets: 'resaleTickets'
};

export const userAccountMenuConstants =
    [{
        id: 'abad0895',
        title: 'Account settings',
        children: [
            { id: 'j785', title: 'Home', form: userAccountContentConstants.accountHomePage },
            { id: 'c156', title: 'My details', form: userAccountContentConstants.userDetailsForm },
            { id: '4088', title: 'Change password', form: userAccountContentConstants.changePasswordForm },
            { id: '9b16', title: 'My addresses', form: userAccountContentConstants.userAddressesForm },
        ]
    },
    // {
    //     id: 'dd8940a9',
    //     title: 'Preference centre',
    //     children: [
    //         { id: 'bbc7', title: 'Preference Centre', form: userAccountContentConstants.emailNotificationSettings },
    //     ]
    // },
    // {
    //     id: '690e99e0',
    //     title: '',
    //     children: [
    //         {
    //             id: 'a377',
    //             title: 'The One Club',
    //             form: userAccountContentConstants.theOneClub,
    //             tag: <span>Member</span>
    //         },
    //     ]
    // },
    {
        id: '783d88f1',
        title: '',
        children: [
            {
                id: 'bf3d',
                title: 'Ticket Resale Platform',
                form: userAccountContentConstants.resaleTickets,
            },
        ]
    },
    {
        id: '7820a8a5',
        title: 'My purchases',
        children: [
            { id: 'c550', title: 'Tickets', form: userAccountContentConstants.userTickets },
            { id: '413b', title: 'View order history', form: userAccountContentConstants.userOrderHistory },
        ]
    }];

export const userAccountFormConstants = {

    /* eslint-disable */
    accountHomePage: ({
        accountFormData,
        userAccountData,
        refreshAccountPage,
        handleViewFileSummaryClick,
        handleViewTicketsClick
    }) => {
        let formData = new AccountHomePageFormData(accountFormData, userAccountData);
        return <AccountHomePage
            formData={formData}
            accountData={userAccountData}
            refreshAccountPage={refreshAccountPage}
            onViewFileSummaryClick={handleViewFileSummaryClick}
            onViewTicketsClick={handleViewTicketsClick}></AccountHomePage>
    },
    userDetailsForm: ({ accountFormData, userAccountData, refreshAccountPage }) => {
        let formData = new UserDetailsFormData(accountFormData, userAccountData);
        return <UserDetailsForm formData={formData} accountData={userAccountData} refreshAccountPage={refreshAccountPage}></UserDetailsForm>
    },
    changePasswordForm: ({ accountFormData, userAccountData }) => {
        let formData = new ChangePasswordFormData(accountFormData, userAccountData)
        return <ChangePasswordForm formData={formData}></ChangePasswordForm>
    },
    userAddressesForm: ({ accountFormData, userAccountData, refreshAccountPage }) => {
        let formData = new UserAddressesDisplayFormData(accountFormData, userAccountData);
        const { country, state } = accountFormData.ssoUserDetailsFields;

        userAccountData[formConstants.emailAddress] = userAccountData[formConstants.email];

        if (userAccountData[formConstants.dateOfBirth] !== undefined) {
            userAccountData[formConstants.dateOfBirth] = createDateFromExisting(userAccountData.dateOfBirth);
        }

        if (!isEmpty(userAccountData[formConstants.addresses])) {
            userAccountData[formConstants.addresses] = userAccountData[formConstants.addresses].map((address) => {

                address[formConstants.addressLine1] = address[formConstants.addressLine1] || formMessageConstants.emptyString;
                address[formConstants.addressLine2] = address[formConstants.addressLine2] || formMessageConstants.emptyString;
                address[formConstants.addressLine3] = address[formConstants.addressLine3] || formMessageConstants.emptyString;
                address[formConstants.postcode] = address[formConstants.postcode] || formMessageConstants.emptyString;
                address[formConstants.city] = address[formConstants.city] || formMessageConstants.emptyString;

                const selectedCountry = getCountry(address.country, country.options);
                address[formConstants.countryName] = selectedCountry.label;

                address[formConstants.county] = address[formConstants.county] || formMessageConstants.emptyString;
                address[formConstants.state] = address[formConstants.state] || formMessageConstants.emptyString;

                const selectedStateName = findOptionInSelectField(state, address[formConstants.state], formFieldConstants.selectFieldOptionsLabel);
                address[formConstants.stateName] = selectedStateName;

                return address;
            });
        }

        return <UserAddressesForm
            formData={formData}
            accountData={userAccountData}
            refreshAccountPage={refreshAccountPage}></UserAddressesForm>
    },
    theOneClub: ({ accountFormData, userAccountData, refreshAccountPage }) => {
        let formData = new TheOneClubFormData(accountFormData, userAccountData);
        return <TheOneClub
            formData={formData}
            accountData={userAccountData}
            refreshAccountPage={refreshAccountPage}></TheOneClub>
    },
    resaleTickets: ({ accountFormData, userAccountData  }) => {
        let formData = new TicketsResaleFormData(accountFormData);
        return <ResaleTickets formData={formData}
        accountData = {userAccountData}
        renderedComponent = {userAccountContentConstants.resaleTickets}
        ></ResaleTickets>
    },
    emailNotificationSettings: ({ accountFormData, userAccountData, refreshAccountPage }) => {
        let formData = new EmailNotificationSettingsFormData(accountFormData, userAccountData);
        return <EmailNotificationSettingsForm
            formData={formData}
            accountData={userAccountData}
            refreshAccountPage={refreshAccountPage}></EmailNotificationSettingsForm>
    },
    pushNotifications: ({ accountFormData, userAccountData }) => {
        return <PushNotificationsForm ></PushNotificationsForm>
    },
    userOrderHistory: ({ accountFormData, userAccountData, fileNumberForDisplay }) => {
        let formData = new OrderHistoryDisplayFormData(accountFormData);
        return <UserOrderHistory formData={formData} fileNumberForDisplay={fileNumberForDisplay}></UserOrderHistory>
    },
    userTickets: ({ accountFormData, userAccountData, upcomingTicket }) => {
        let formData = new UserTicketsDisplayFormData(accountFormData, userAccountData);
        return <UserTickets formData={formData} upcomingTicket={upcomingTicket}></UserTickets>
    }
    /* eslint-enable */
};

function getCountry(country, options) {
    const value = options.find((x) => x.code === country);

    if (value == null) { return options[0]; }

    return value;
}
